// @ts-nocheck
/**
 * Function used to dynmically load a Webpack 5 federated module
 * Imports and loads a script from the webpack 5 url and appends to the host app's DOM
 * Which will enable use of the module specified from the given url
 * @param moduleName name of module (e.g. 'report_library')
 * @param moduleUrl url of module (e.g. 'http://localhost:9010/remoteEntry.js')
 * @returns Webpack 5 module
 */
// Based on: https://github.com/webpack/webpack/issues/11033#issuecomment-834559345
export default async function loadWebpackModule(moduleName, moduleUrl) {
  await __webpack_init_sharing__('default');

  await new Promise((resolve, reject) => {
    const element = document.createElement('script');

    element.src = moduleUrl;
    element.type = 'text/javascript';
    element.async = true;

    element.onload = () => {
      if (element.parentElement) element.parentElement.removeChild(element);
      resolve();
    };

    element.onerror = (err) => {
      if (element.parentElement) element.parentElement.removeChild(element);
      reject(err);
    };

    document.head.appendChild(element);
  });

  const container = window[moduleName];
  await container.init(__webpack_share_scopes__.default);

  const factory = await container.get('.');

  return factory();
}
